/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseModule } from './courseModule';

export type GenericApiResponseListCourseModuleData = CourseModule[] | null;
